export default __webpack_public_path__ + "static/media/Start.77a4f677.png";